'use client'

import { useEffect } from 'react'
import analyticsService from '../lib/analyticsService'

interface CookiePreferences {
  essential: boolean
  analytics: boolean
  functional: boolean
  marketing: boolean
}

export default function CustomAnalytics() {
  const initializeAnalytics = () => {
    // Enable our custom analytics service
    analyticsService.setEnabled(true)

    // Track initial page view
    analyticsService.trackPageView()
  }

  useEffect(() => {
    // Check if analytics cookies are already accepted
    const consent = localStorage.getItem('cookie-consent')
    if (consent) {
      const preferences: CookiePreferences = JSON.parse(consent)
      if (preferences.analytics) {
        initializeAnalytics()
      }
    }

    // Listen for cookie consent changes
    const handleConsentChange = (event: CustomEvent) => {
      if (event.detail?.analytics) {
        initializeAnalytics()
      } else {
        // Disable analytics if consent is withdrawn
        analyticsService.setEnabled(false)
      }
    }

    window.addEventListener('cookie-consent-changed', handleConsentChange as EventListener)

    return () => {
      window.removeEventListener('cookie-consent-changed', handleConsentChange as EventListener)
    }
  }, [])

  return null // This component doesn't render anything
}
